mutation updateAvv($companyId: ID!) {
  updateAvv(companyId: $companyId)
}
